/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientIdentity
 */
export interface ClientIdentity {
    /**
     * 
     * @type {string}
     * @memberof ClientIdentity
     */
    identityId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientIdentity
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientIdentity
     */
    companyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientIdentity
     */
    isAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientIdentity
     */
    maltPlusAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientIdentity
     */
    shareableInvitationLink?: string;
}

/**
 * Check if a given object implements the ClientIdentity interface.
 */
export function instanceOfClientIdentity(value: object): value is ClientIdentity {
    if (!('isAdmin' in value) || value['isAdmin'] === undefined) return false;
    return true;
}

export function ClientIdentityFromJSON(json: any): ClientIdentity {
    return ClientIdentityFromJSONTyped(json, false);
}

export function ClientIdentityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientIdentity {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'isAdmin': json['isAdmin'],
        'maltPlusAvailable': json['maltPlusAvailable'] == null ? undefined : json['maltPlusAvailable'],
        'shareableInvitationLink': json['shareableInvitationLink'] == null ? undefined : json['shareableInvitationLink'],
    };
}

export function ClientIdentityToJSON(value?: ClientIdentity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'isAdmin': value['isAdmin'],
        'maltPlusAvailable': value['maltPlusAvailable'],
        'shareableInvitationLink': value['shareableInvitationLink'],
    };
}

